/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable comma-dangle */

import './App.css';
import { connect } from 'react-redux';
import React from 'react';
import { motion } from 'framer-motion';
import { useIdleTimer } from 'react-idle-timer';
import moment from 'moment';
import { AwsRum } from 'aws-rum-web';
import { ToastProvider } from './context/ToastContext';

import { alertActions } from './redux/actions/alert.action';
import { UserActions } from './redux/actions/user.action';
import NavigationRoutes from './routes';
import { userService } from './service/user.service';

if (process.env.REACT_APP_STAGE === 'prod') {
    try {
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "ap-south-1:f28bfb3d-122d-4dcc-8fe0-5384e3b4d218",
            endpoint: "https://dataplane.rum.ap-south-1.amazonaws.com",
            telemetries: ["performance", "errors", "http"],
            allowCookies: true,
            enableXRay: false
        };

        const APPLICATION_ID = 'bf105b7f-338c-4c36-a198-fc0a420d57ba';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'ap-south-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}
export default function App(props) {
    const NavigationPath = NavigationRoutes(props);
    const [authorized, setAuthorized] = React.useState(false);

    const onIdle = () => {
        localStorage.removeItem('user');
        window.location.reload();
    };

    const refreshToken = async () => {
        const response = await userService.UsersList(1, '', '', 'created_at+desc');
        if (response.refresh === true) {
            // window.location.reload();
        } else {
            setAuthorized(true);
        }
    };

    useIdleTimer({
        onIdle,
        timeout: 1800000,
        promptTimeout: 0,
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange'
        ],
        immediateEvents: [],
        debounce: 0,
        throttle: 0,
        eventsThrottle: 200,
        element: document,
        startOnMount: true,
        startManually: false,
        stopOnIdle: false,
        crossTab: false,
        name: 'idle-timer',
        syncTimers: 0,
        leaderElection: false
    });

    React.useEffect(() => {
        if (localStorage.getItem('user')) {
            if (localStorage.getItem('login_time')) {
                const storedDate = moment(localStorage.getItem('login_time'));
                const currentDate = moment();
                if (!currentDate.isSame(storedDate, 'day')) {
                    localStorage.clear();
                    window.location.reload();
                }
            }
            if (authorized === false) {
                refreshToken();
            }
        }
    }, []);

    return (
        <ToastProvider>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
            >
                {NavigationPath}
            </motion.div>
        </ToastProvider>
    );
}

function mapState(state) {
    const { loggedIn } = state.authentication;
    return { loggedIn };
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    login: UserActions.login,
    VerifyOtp: UserActions.VerifyOtp,
    resendOtp: UserActions.resendOtp,

};

const connectedApp = connect(mapState, actionCreators)(App);
export { connectedApp as App };
